import { useRef, useEffect } from 'react';

export interface VideoNativeProps {
  className?: string;
  autoPlay?: boolean;
  controls?: boolean;
  muted?: boolean;
  style?: Record<any, any>;
}

interface VideoProps {
  children: any;
  muted: boolean;
  nativeProps?: VideoNativeProps;
}

const Video = (props: VideoProps) => {
  const { children, nativeProps, muted } = props;
  const videoRef: any = useRef(null);

  useEffect(() => {
    if (muted) {
      videoRef.current.muted = true;
      videoRef.current.setAttribute('muted', '');
    }
    videoRef.current.play();
  }, [muted]);

  return (
    <video ref={videoRef} preload="metadata" playsInline loop {...nativeProps}>
      {children}
    </video>
  );
};

export default Video;
